/**
 * Shared React Query options for firm-facing reads (firm list, firm detail,
 * firm reviews).
 *
 * These payloads carry moderated/derived counters — `reviewCount`, `avgRating`,
 * `savedCount` — that change from OUTSIDE this browser tab (a super-admin
 * approving a review, another device saving the firm). The global provider
 * defaults (5 min staleTime, no refetch on focus) meant a visitor kept seeing
 * the old numbers until a hard browser refresh, and listing cards disagreed
 * with the detail page.
 *
 * `refetchOnMount: 'always'` still paints the cached data instantly — the
 * revalidation happens in the background — so this costs no perceived latency.
 */
export const LIVE_FIRM_DATA_OPTIONS = {
  staleTime: 1000 * 30,
  gcTime: 1000 * 60 * 30,
  refetchOnMount: 'always',
  refetchOnWindowFocus: true,
};
